<template>
  <div class="modal-wrapper">
    <div class="modal" :class="{ 'modal-initial' : otpusk.worker !== undefined }">
      <div class="modal-header" :class="{ 'modal-header-named' : otpusk.worker !== undefined }">
        <div class="new-input" v-if="otpusk.worker === undefined">
          <span class="miv">N</span>
          <input type="text" placeholder="Търсене" v-model="searchUsers" />
        </div>
        <h1 v-else>
          <span class="miv2" @click="resetWorker()">K</span>
          {{otpusk.worker.name}}
        </h1>
        <span class="miv modal-close" @click="close(false)">F</span>
      </div>
      <div class="modal-content" v-if="otpusk.worker === undefined">
        <p class="category-p" v-if="!searchUsers">Всички работници</p>
        <div
          class="modal-content-item"
          v-for="(w) in filteredWorkers"
          v-show="!w.hide"
          :key="`addWorkersModal-${w._id}`"
          @click="selectWorker(w)"
        >
          <span class="icon">B</span>
          {{w.name}}
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="!filteredWorkers.length">
          Няма намерени резултати за '
          <strong>{{this.searchUsers}}</strong>'
        </p>
      </div>
      <div class="modal-content" v-else>
        <template v-if="!selectDateFrom && !selectDateTo">
          <div class="row">
            <p>Дати:</p>
            <p class="fake-input" @click="selectDateFrom = true">
              <span class="miv2">F</span>
              Начало на отпуск: {{ otpusk.dateFrom | formatDate }}
              <span class="miv">c</span>
            </p>
            <p class="fake-input" @click="toggleDateTo()">
              <span class="miv2">F</span>
              Край на отпуск: {{ otpusk.dateTo | formatDate }}
              <span class="miv">c</span>
            </p>
          </div>
          <div class="row">
            <p>Тип на отпуск:</p>
            <span
              v-for="o of allowedOtpuskTypes"
              :key="o.type"
              :class="[
                `toggle-type toggle-type-${o.type}`,
                { 'toggle-type-active': o.type === otpusk.type },
              ]"
              @click="otpusk.type = o.type"
            >
              {{ o.name }}
            </span>
          </div>
          <div class="row" v-if="limit">
            <p>Баланс:</p>
            <p
              class="balance"
              :class="{ 'balance-exceeded': isBalanceExceeded }"
            >
              Остават <strong>{{ limit.remaining }}</strong> от
              {{ limit.total }} дни {{ limit.name }} за {{ balance.year }} г.
              <template v-if="limit.pending">
                ({{ limit.pending }} чакащи одобрение)
              </template>
              <template v-if="otpusk.dateFrom && otpusk.dateTo">
                <br />
                Заявени: <strong>{{ requestedDays }}</strong> работни дни
              </template>
              <template v-if="isBalanceExceeded">
                <br />
                <strong v-if="otpusk.type === 'paid'">Изчерпан баланс - не може да въведете нов платен отпуск.</strong>
                <strong v-else>Надвишен лимит - не може да въведете неплатен отпуск над {{ limit.total }} работни дни за годината.</strong>
              </template>
            </p>
          </div>
          <div class="row">
            <p>Коментар:</p>
            <div class="new-input">
              <input
                type="text"
                placeholder="Допълнителен коментар (незадължителен)"
                v-model="otpusk.comment"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <p class="category-p" v-if="!otpusk.dateFrom">Изберете начална дата на отпуската</p>
          <p
            class="category-p"
            v-if="otpusk.dateFrom && !otpusk.dateTo"
          >Изберете крайна дата на отпуската</p>
        </template>
        <datepicker
          v-if="selectDateFrom"
          :language="bg"
          :inline="true"
          :monday-first="true"
          :minimumView="'day'"
          :maximumView="'day'"
          :full-month-name="true"
          v-model="otpusk.dateFrom"
          @selected="selectedDateFrom"
        ></datepicker>
        <datepicker
          v-if="selectDateTo"
          :language="bg"
          :inline="true"
          :monday-first="true"
          :minimumView="'day'"
          :maximumView="'day'"
          :full-month-name="true"
          v-model="otpusk.dateTo"
          @selected="selectedDateTo"
        ></datepicker>
      </div>
      <div class="modal-footer" v-if="otpusk.worker !== undefined">
        <button class="btn btn-new" @click="save()">
          <span class="miv">Y</span>
          Запази
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { bg } from 'vuejs-datepicker/dist/locale';
import { mapGetters } from 'vuex';
import log from '../mixins/log';
import holidays from '../mixins/holidays';
export default {
  components: {
    Datepicker: Datepicker
  },
  mixins: [log, holidays],
  props: ['date'],
  data() {
    return {
      bg: bg,
      workers: [],
      searchUsers: '',
      selectedWorker: undefined,
      selectDateFrom: false,
      selectDateTo: false,
      // paid leave balance and unpaid limit of the selected worker
      balance: undefined,
      otpusk: {
        worker: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        type: '',
        comment: ''
      },
      otpuskTypes: [
        { name: "Платен", type: "paid" },
        { name: "Неплатен", type: "unpaid" },
        { name: "Болничен", type: "hospital" },
        { name: "Фиктивен-Неплатен", type: "fake" },
        { name: "Неприсъствен", type: "notpresent" },
        { name: "Командировка с преспиване", type: "tripovernight" },
        { name: "Командировка без преспиване", type: "tripday" },
      ],
    };
  },
  computed: {
    filteredWorkers() {
      return this.filterWorkers();
    },
    // the balance is for the year of the start date
    balanceYear() {
      return (this.otpusk.dateFrom
        ? new Date(this.otpusk.dateFrom)
        : new Date()
      ).getFullYear();
    },
    // working days in the balance year
    requestedDays() {
      if (!this.otpusk.dateFrom || !this.otpusk.dateTo) return 0;

      const to = new Date(this.otpusk.dateTo);
      const yearEnd = new Date(this.balanceYear, 11, 31);

      return this.calculateHolidays(
        this.otpusk.dateFrom,
        to > yearEnd ? yearEnd : to
      );
    },
    // the paid balance or the unpaid limit for the selected type
    limit() {
      const b = this.balance;
      if (!b || !b.tracked) return null;

      if (this.otpusk.type === 'paid') {
        return {
          name: 'платен отпуск',
          total: b.available,
          pending: b.pending,
          remaining: b.remaining
        };
      }
      if (this.otpusk.type === 'unpaid' && b.unpaid) {
        return {
          name: 'неплатен отпуск',
          total: b.unpaid.limit,
          pending: b.unpaid.pending,
          remaining: b.unpaid.remaining
        };
      }
      return null;
    },
    isBalanceExceeded() {
      return !!this.limit && this.requestedDays > this.limit.remaining;
    },
    // "Неприсъствен" is added only by the office
    allowedOtpuskTypes() {
      const p = this.getUser.permissions;
      return this.otpuskTypes.filter(
        o =>
          o.type !== 'notpresent' || p.isAdmin || p.isSuperAdmin || p.isHR
      );
    },
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser'
      // ...
    ])
  },
  watch: {
    'otpusk.worker'() {
      this.getBalance();
    },
    balanceYear() {
      this.getBalance();
    }
  },
  methods: {
    getBalance() {
      this.balance = undefined;
      if (!this.otpusk.worker) return;

      const workerId = this.otpusk.worker._id;
      const year = this.balanceYear;

      this.$http
        .get(
          `${process.env.VUE_APP_BASE_URI}/otpusk/balance/${workerId}?year=${year}`
        )
        .then(response => {
          // the worker/year may be changed meanwhile
          if (
            this.otpusk.worker &&
            this.otpusk.worker._id === workerId &&
            this.balanceYear === year
          ) {
            this.balance = response.data;
          }
        })
        .catch(err => console.log(err));
    },
    getWorkers() {
      this.workers = [];
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/workers?active=true`)
        .then(response => {
          this.workers = response.data;
        });
    },
    filterWorkers() {
      return this.workers.filter(w => {
        return w.name.toLowerCase().includes(this.searchUsers.toLowerCase());
      });
    },
    selectWorker(w) {
      // this.otpusk.dateFrom = this.date ? new Date(this.date) : new Date();
      // this.otpusk.dateTo = this.date ? new Date(this.date) : new Date();
      this.$set(this.otpusk, 'worker', w);
    },
    selectedDateFrom() {
      this.$nextTick(() => {
        if (!this.otpusk.dateTo || this.otpusk.dateFrom > this.otpusk.dateTo) {
          this.otpusk.dateTo = new Date(this.otpusk.dateFrom);
        }
      });

      this.selectDateFrom = false;
    },
    selectedDateTo() {
      this.$nextTick(() => {
        if (this.otpusk.dateTo < this.otpusk.dateFrom) {
          this.otpusk.dateFrom = new Date(this.otpusk.dateTo);
        }
      });

      this.selectDateTo = false;
    },
    toggleDateTo() {
      if (this.otpusk.dateFrom) {
        this.selectDateTo = true;
      } else {
        this.$snotify.error('Първо изберете начална дата');
      }
    },
    resetDate(d) {
      this.$set(this.otpusk, d, undefined);
    },
    resetWorker() {
      this.selectWorker(undefined);
      this.resetDate('dateFrom');
      this.resetDate('dateTo');
    },
    close(update) {
      this.$parent.$emit('closeAddOtpuskModal', update);
    },
    save() {
      if (this.isValid()) {
        this.$store.dispatch('startLoading');
        this.otpusk.createdBy = this.getUser._id;
        let requestUrl = `${process.env.VUE_APP_BASE_URI}/otpusk`;
        this.$http
          .post(requestUrl, this.otpusk)
          .then(() => {
            this.$store.dispatch('stopLoading');
            this.$snotify.success('Успешно добавен отпуск!');
            this.newLog(
              'newOtpusk',
              `на ${
                this.otpusk.worker.name
              } от ${this.$options.filters.formatDate(
                this.otpusk.dateFrom
              )} до ${this.$options.filters.formatDate(this.otpusk.dateTo)}`
            );
            this.close(true);
          })
          .catch(err => {
            console.log(err);
            this.$store.dispatch('stopLoading');
            // validation errors (e.g. existing report) keep the modal opened
            if (err.response && err.response.data && err.response.data.failed) {
              this.$snotify.error(err.response.data.failed);
              return;
            }
            this.$snotify.error(`Нещо се обърка`);
            this.close(false);
          });
      }
    },
    isValid() {
      if (this.otpusk.worker === undefined) {
        return false;
      }
      if (this.otpusk.dateFrom === undefined) {
        return false;
      }
      if (this.otpusk.dateTo === undefined) {
        return false;
      }
      if (!this.otpusk.type) {
        this.$snotify.error('Не сте избрали тип на отпуска!');
        return false;
      }
      if (this.isBalanceExceeded) {
        this.$snotify.error(
          this.otpusk.type === 'paid'
            ? 'Изчерпан баланс платен отпуск!'
            : 'Надвишен лимит неплатен отпуск!'
        );
        return false;
      }
      if (this.otpusk.dateFrom > this.otpusk.dateTo) {
        this.$snotify.error(
          'Началната дата не може да е по-голяма от крайната!'
        );
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.getWorkers();
  }
};
</script>

<style scoped>
.modal-initial {
  width: initial;
}
.modal-initial .modal-content {
  flex-direction: column;
  flex-wrap: nowrap;
}
.modal-header-named {
  justify-content: flex-start;
}
.modal-header-named h1 {
  color: #fff;
  font-size: 20px;
  padding: 0 20px;
}
.modal-header-named h1 .miv2 {
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  margin-right: 10px;
  padding: 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.modal-header-named h1 .miv2:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.modal-content-item {
  cursor: pointer;
  padding-left: 30px;
  padding-right: 10px;
  width: calc(33.33% - 20px);
}
.modal-content-item .icon {
  font-family: 'miv';
  left: 10px;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
}
.modal-footer {
  justify-content: center;
}
.row {
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  width: 100%;
}
.row:last-of-type {
  margin-bottom: 0;
}
.category-p {
  font-weight: 700;
  margin: 0 0 15px;
  text-align: center;
  width: 100%;
}
.toggle-type {
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  margin-left: 10px;
  opacity: 0.8;
  padding: 5px;
  text-align: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 163.33px;
  /* width: 120px; */
}
.toggle-type:hover {
  opacity: 1;
}
.toggle-type-active {
  color: #fff;
  font-weight: 700;
  opacity: 1;
}
.toggle-type-paid {
  background-color: #e6f3e6;
}
.toggle-type-unpaid {
  background-color: #f3eae6;
}
.toggle-type-hospital {
  background-color: #e6ecf3;
}
.toggle-type-fake {
  background-color: #f3e99a;
}
.toggle-type-notpresent {
  background-color: #e3e3e3;
}
.toggle-type-tripovernight,
.toggle-type-tripday {
  background-color: #cfe2f3;
}
.toggle-type-active.toggle-type-paid {
  background-color: #9bbb59;
}
.toggle-type-active.toggle-type-unpaid {
  background-color: #c0504d;
}
.toggle-type-active.toggle-type-hospital {
  background-color: #4f81bd;
}
.toggle-type-active.toggle-type-fake {
  background-color: #d9c009;
}
.toggle-type-active.toggle-type-notpresent {
  background-color: #7f7f7f;
}
.toggle-type-active.toggle-type-tripovernight,
.toggle-type-active.toggle-type-tripday {
  background-color: #3d85c6;
}
.balance {
  background-color: #e6f3e6;
  border-radius: 4px;
  flex: 1;
  line-height: 1.5;
  margin-left: 10px;
  padding: 5px 10px;
}
.balance-exceeded {
  background-color: #f8dcdc;
  color: #d91313;
}
.fake-input {
  align-items: center;
  background-color: #f4f4f4;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex: 1;
  height: 40px;
  justify-content: space-between;
  margin-left: 10px;
  padding: 0 10px;
  white-space: nowrap;
  width: 250px;
}
.fake-input:hover {
  opacity: 0.8;
}
.fake-input .miv2 {
  margin-right: 10px;
}
.fake-input .miv {
  color: #3b86ff;
  margin-left: 10px;
}
.modal-content .new-input {
  width: 510px;
  flex: 1;
  margin: 0 0 0 10px;
}
.modal-content .new-input input {
  padding: 5px 10px;
}
.row p:first-child {
  width: 100px;
  min-width: 100px;
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-initial {
    width: initial;
    max-width: 90%;
  }
  .modal-initial .modal-content {
    max-height: 60vh;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-footer {
    flex-direction: column;
    height: 60px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .row {
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 0;
  }
  .row p:first-child {
    width: 100%;
    margin-bottom: 10px;
  }
  .fake-input {
    margin: 0 0 10px 0;
    flex: initial;
    width: 100%;
  }
  .toggle-type {
    margin: 0 0 10px 0;
    width: 100%;
  }
  .balance {
    margin: 0 0 10px 0;
    width: 100%;
  }
  .modal-content .new-input {
    margin: 0;
    width: 100%;
    flex: initial;
  }
}
</style>
